import styled from 'styled-components';
import { baseVariables, toRem, constants } from '@marriott/mi-ui-library';
import { FONT_ICON_SIZES } from './MerchandisingHeroBannerAsset.types';
const { xl } = { ...baseVariables.mediaQuery };

const logoResize = (fontIcon: string) => {
  return FONT_ICON_SIZES[fontIcon]?.mobileSize
    ? `font-size: ${toRem(FONT_ICON_SIZES[fontIcon]?.mobileSize)};
    line-height: 1.25;
    @media ${baseVariables.mediaQuery.lg} {
      font-size: ${toRem(FONT_ICON_SIZES[fontIcon]?.deskTopSize)};
    }`
    : '';
};

export const StyledVerticalImageContainer = styled.div`
  .styledverticalImage {
    max-width: 100%;
    max-height: 100%;
  }

  max-width: ${toRem(132)};
  max-height: ${toRem(97)};
  margin-top: ${toRem(5)};
  margin-right: 0;
  margin-bottom: ${toRem(20)};
  align-self: center;

  @media ${baseVariables.mediaQuery.md} {
    margin-right: 0.5rem;
    margin-bottom: 0;
    max-width: ${toRem(162)};
    max-height: ${toRem(119)};
    align-self: flex-start;
  }
  @media ${baseVariables.mediaQuery.lg} {
    max-width: ${toRem(270)};
    max-height: ${toRem(198)};
  }
  .hero-3x1 & {
    margin-bottom: ${toRem(8)};
    @media ${baseVariables.mediaQuery.sm} {
      margin-bottom: ${toRem(0)};
    }
  }
`;

export const StyledLogoImage = styled.div<{ cobrandmathhero: boolean }>`
  height: ${toRem(60)};
  margin-bottom: ${toRem(10)};
  @media ${baseVariables.mediaQuery.md} {
    margin-bottom: ${({ cobrandmathhero }) => (cobrandmathhero ? toRem(6) : toRem(16))};
    height: ${toRem(60)};
  }
  @media ${baseVariables.mediaQuery.lg} {
    height: ${toRem(100)};
    margin-bottom: ${toRem(16)};
  }

  &.herobanner3X1__creditcard {
    height: ${toRem(57)};
    @media ${baseVariables.mediaQuery.md} {
      height: ${toRem(67)};
    }
    @media ${xl} {
      height: ${toRem(90)};
    }
  }

  .hero-2x1 & {
    height: ${toRem(60)};
    margin-bottom: ${toRem(10)};
    @media ${baseVariables.mediaQuery.md} {
      margin-bottom: ${({ cobrandmathhero }) => (cobrandmathhero ? toRem(6) : toRem(16))};
    }
    @media ${baseVariables.mediaQuery.lg} {
      height: ${toRem(100)};
      margin-bottom: ${toRem(16)};
    }
  }

  .hero-3x1 & {
    height: ${toRem(60)};
    margin-bottom: ${toRem(24)};
    @media ${baseVariables.mediaQuery.md} {
      margin-bottom: ${toRem(12)};
    }
    @media ${baseVariables.mediaQuery.lg} {
      height: ${toRem(100)};
      margin-bottom: ${toRem(24)};
    }
  }
  img {
    height: 100%;
    padding-left: ${toRem(8)};
  }
  &.hb-flex {
    width: unset;
  }
`;

export const StyledFontIcon = styled.span<{ fontIcon: string }>`
  &.m-icon {
    display: inline-block;
    margin-bottom: 1rem;
    &:hover {
      background: transparent;
    }
    &::before {
      ${logoResize(constants.DEFAULT)}
    }
    &.brand {
      &-logo-${props => props.fontIcon}::before {
        ${props => logoResize(props.fontIcon)}
      }
      &-logo-Escape {
        &::before {
          font-size: unset;
          line-height: unset;
        }
        font-size: 4.22rem;
        margin-left: -1.4rem;
        @media ${baseVariables.mediaQuery.lg} {
          font-size: 5.275rem;
          margin-left: -1.5rem;
        }
      }
    }
  }
`;
